import { jsPDF } from "jspdf";
import logo from "../../../../assets/images/darkthemelogo.svg";
import { formatValue } from "./calculatorLogic";

const getLogoPngData = async (alpha = 1) => {
  try {
    const svgText = await fetch(logo).then((res) => res.text());
    const svgBlob = new Blob([svgText], { type: "image/svg+xml;charset=utf-8" });
    const svgUrl = URL.createObjectURL(svgBlob);

    return await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const width = Math.max(img.width || 320, 320);
        const height = Math.max(img.height || 120, 120);
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.clearRect(0, 0, width, height);
          ctx.globalAlpha = alpha;
          ctx.drawImage(img, 0, 0, width, height);
        }
        const pngDataUrl = canvas.toDataURL("image/png");
        URL.revokeObjectURL(svgUrl);
        resolve({ pngDataUrl, width, height });
      };
      img.onerror = () => {
        URL.revokeObjectURL(svgUrl);
        resolve(null);
      };
      img.src = svgUrl;
    });
  } catch (_error) {
    return null;
  }
};

const buildRows = (form, result, labels) => [
  [labels.description, labels.amount],
  [labels.totalArea, `${formatValue(result.area, 0)} ${result.unit}`],
  [labels.board, `${result.Board} ${labels.unitPcs}`],
  [labels.trackUd, `${formatValue(result.UD, 0)} ${labels.unitM}`],
  [labels.studCw, `${formatValue(result.CW, 0)} ${labels.unitM}`],
  [labels.jointTape, `${formatValue(result.Tape, 0)} ${labels.unitM}`],
  [labels.jointCompound, `${formatValue(result.Filler, 0)} ${labels.unitKg}`],
  [labels.screws25, `${formatValue(result.Screws25, 0)} ${labels.unitPcs}`],
  ...(form.boardSides === "two"
    ? [[labels.screws35, `${formatValue(result.Screws35, 0)} ${labels.unitPcs}`]]
    : []),
  [labels.waferHead, `${formatValue(result.WaferHead, 0)} ${labels.unitPcs}`],
  [labels.anchors, `${formatValue(result.Anchors, 0)} ${labels.unitPcs}`],
  [labels.studSpacing, labels.studSpacingValue],
  [labels.waste, labels.wasteValue],
];

export const downloadEstimatorPdf = async ({ form, result, labels }) => {
  if (!result?.calculated || !labels) return;

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const headerLogo = await getLogoPngData(1);
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const left = 13;
  const right = pageWidth - 13;

  if (headerLogo) {
    const logoWidth = 42;
    const logoHeight = (headerLogo.height / headerLogo.width) * logoWidth;
    doc.addImage(headerLogo.pngDataUrl, "PNG", right - logoWidth, 10, logoWidth, logoHeight);
  }

  const rows = buildRows(form, result, labels);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(6, 32, 76);
  doc.text(labels.pdfTitle, left, 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor(60);
  doc.text(labels.pdfInput, left, 33);
  doc.text(labels.pdfDateGenerated, right, 33, { align: "right" });

  doc.setDrawColor(200);
  doc.line(left, 36, right, 36);

  const tableTop = 42;
  const rowHeight = 10;
  const col1Width = 95;
  const col2Width = right - left - col1Width;
  let y = tableTop;
  rows.forEach(([label, value], index) => {
    if (index === 0) {
      doc.setFillColor(242, 112, 45);
      doc.rect(left, y, col1Width, rowHeight, "F");
      doc.setFillColor(0, 24, 68);
      doc.rect(left + col1Width, y, col2Width, rowHeight, "F");
      doc.setTextColor(255);
    } else {
      const isBlueStrip = index % 2 === 0;
      doc.setFillColor(isBlueStrip ? 244 : 255, isBlueStrip ? 250 : 255, 255);
      doc.rect(left, y, col1Width, rowHeight, "F");
      doc.rect(left + col1Width, y, col2Width, rowHeight, "F");
      doc.setTextColor(20);
    }

    doc.setDrawColor(120);
    doc.setLineWidth(0.2);
    doc.rect(left, y, col1Width, rowHeight);
    doc.rect(left + col1Width, y, col2Width, rowHeight);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.text(String(label), left + 2, y + 6.3);
    doc.setFont("helvetica", "bold");
    doc.text(String(value), right - 2, y + 6.3, { align: "right" });
    y += rowHeight;
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(242, 112, 45);
  doc.text(labels.pdfNoteLabel, left, y + 10);
  doc.setTextColor(90);
  doc.text(labels.pdfNoteText, left + 12, y + 10);

  const footerY = pageHeight - 18;
  doc.setTextColor(90);
  doc.setFontSize(10);
  doc.text("+964 750 202 0066   |   +964 770 141 7070   |   +964 770 141 7171", left, footerY);
  doc.text("info@irqgyp.com", right, footerY, { align: "right" });
  doc.setDrawColor(220);
  doc.line(left, footerY + 4, right, footerY + 4);

  doc.save(`drywall-estimate-${new Date().getTime()}.pdf`);
};
